var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',{staticClass:"container-custom page"},[_c('v-row',[(_vm.loading)?_c('v-col',{attrs:{"md":"12"}},[_vm._v("Loading...")]):_vm._e(),(!_vm.loading)?_c('v-col',{attrs:{"md":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.description)}})]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }